import styles from "./addAlert.module.css";
import { Link, useHistory } from "react-router-dom";
import { Typography, Box, Button, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, IconButton, Slide, Snackbar } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import { toast } from 'react-smart-toaster';
import { useAuth0 } from "@auth0/auth0-react";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";
import Loader from "../../../../components/Loader";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const schema = yup.object().shape({
  is_published: yup.string().required("This field is Required"),
  title: yup.string().required("This field is Required"),
  start_date: yup.date().required("This field is Required"),
  end_date: yup.date().required("This field is Required"),
  property_ids: yup.array().required("This field is Required").nullable(),
  description: yup.string().required("This field is Required"),
});

const AddArticle = ({ history, match }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { id } = match.params;
  const redirect = useHistory();
  const [loading, setLoading] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [isPublished, setIsPublished] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");


  const { handleSubmit, control, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      title: "",
      is_published: 0,
      property_ids: [],
    },
  });

  useEffect(() => {
    const getPropertyList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/property-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setPropertyList(response.data.data);
      }).catch(() => {
        setPropertyList([]);
      });
    };

    getPropertyList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const getDetails = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/alerts/" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        let responseData = response.data.data;

        setValue("title", responseData?.title);
        setValue("start_date", dayjs(responseData?.start_date));
        setValue("end_date", dayjs(responseData?.end_date));
        setValue("property_ids", responseData?.property_id_arr);
        setValue("description", responseData?.description);
        setValue("is_published", responseData?.is_published);
        setSelectedProperties(responseData?.property_id_arr);
        setIsPublished(responseData?.is_published);
      });
    };

    if (id) {
      getDetails();
    }
  }, [id, getAccessTokenSilently, setValue]);

  const onSubmit = async (data) => {
    let postData = {
      is_published: data?.is_published,
      title: data?.title,
      description: data?.description,
      start_date: dayjs(data?.start_date).format("YYYY-MM-DD"),
      end_date: dayjs(data?.end_date).format("YYYY-MM-DD"),
    };

    if (data?.property_ids?.length) {
      postData = { ...postData, properties: data?.property_ids };
    }

    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.post(process.env.REACT_APP_RESOURCE_API_URL + "v1/alerts", postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      let logData = {
        title: "A new comminty board has been added.",
        description: [
          "Title: " + response.data.data?.title,
          "Valid On: " + dayjs(response.data.data?.start_date).format("MMM D, YYYY") + " to " + dayjs(response.data.data?.end_date).format("MMM D, YYYY"),
          "Properties: " + response.data.data?.property_names.join(", "),
        ],
      };
      AddLogCallAPI(logData, token);

      setTimeout(() => {
        redirect.push('/communication/community-boards');
      }, 2000);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onUpdate = async (data) => {
    let postData = {
      is_published: data?.is_published,
      title: data?.title,
      description: data?.description,
      start_date: dayjs(data?.start_date).format("YYYY-MM-DD"),
      end_date: dayjs(data?.end_date).format("YYYY-MM-DD"),
    };

    if (data?.property_ids?.length) {
      postData = { ...postData, properties: data?.property_ids };
    }

    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.post(process.env.REACT_APP_RESOURCE_API_URL + "v1/alerts/" + id, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      let logData = {
        title: "Comminty board has been updated",
        description: [
          "Title: " + response.data.data?.title,
          "Valid On: " + dayjs(response.data.data?.start_date).format("MMM D, YYYY") + " to " + dayjs(response.data.data?.end_date).format("MMM D, YYYY"),
          "Properties: " + response.data.data?.property_names.join(", "),
        ],
      };
      AddLogCallAPI(logData, token);

      setTimeout(() => {
        redirect.push('/communication/community-boards');
      }, 2000);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  return (<>
    {loading && <Loader />}
    <Helmet title={id ? "Update Community Board" : "Add Community Board"} />
    <div className={`${styles.mainCard}`}>
      <div className={`${styles.SMProCusRow}`}>
        <div className={`${styles.BreadcrumbHeadSec}`}>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>{" "}Resources</li>
              <li className={`${styles.breadcrumbItem}`}>Community Board</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>{id ? "Update" : "Add"}</li>
            </ol>
          </nav>
          <div className={`${styles.PageTitleSec}`}>
            <div>
              <Link to={`/communication/community-boards`} className={`${styles.BackArrow}`}><ArrowLeft /></Link>
              <Typography display="inline" className={`${styles.pageTitle}`}>Community Board</Typography>
            </div>
          </div>
        </div>

        <div className={`${styles.ExpensesAddMainSec}`}>
          <form onSubmit={handleSubmit(id ? onUpdate : onSubmit)}>
            <div className={`${styles.AddArticleRow}`}>
              <div className={`${styles.AddArticleBigSec}`}>
                <div className={`${styles.FormGroupTextareaFull}`}>
                  <Controller
                    name="description"
                    control={control}
                    render={(field) => (<Editor
                      className={`${styles.formControlTextArea}`}
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={field?.value}
                      init={{
                        height: 600,
                        menubar: false,
                        plugins: ["lists"],
                        toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor removeformat | alignleft aligncenter alignright alignjustify | numlist bullist |  fullscreen  | ltr rtl",
                      }}
                      onEditorChange={(e) => field.onChange(e)}
                    />)}
                  />
                  {errors.description && (
                    <p className={`${styles.ErrorM}`}>{errors.description.message}</p>
                  )}
                </div>
              </div>
              <div className={`${styles.AddArticleSmallSec}`}>
                <div className={`${styles.AddDocTitleSec}`}>
                  <div className={`${styles.FormGroupAddLease} FormGroup`}>
                    <FormControl sx={{ m: 1, width: 300 }}>
                      <InputLabel id="demo-multiple-chip-label">Status*</InputLabel>
                      <Controller
                        name="is_published"
                        control={control}
                        render={(field) => (
                          <Select
                            {...field}
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            label={"Status*"}
                            onChange={(e) => {
                              field.onChange(e);
                              setIsPublished(e.target.value);
                            }}
                          >
                            <MenuItem value={0}>Draft</MenuItem>
                            <MenuItem value={1}>Publish</MenuItem>
                          </Select>)}
                      />
                    </FormControl>
                    {errors.is_published && (<p className={`${styles.ErrorM}`}>{errors.is_published.message}</p>)}
                  </div>
                </div>
                <div className={`${styles.AddDocTitleSec}`}>
                  <div className={`${styles.FormGroupAddLease} FormGroup`}>
                    <FormControl sx={{ m: 1, width: 300 }}>
                      <InputLabel id="demo-multiple-chip-label">Property*</InputLabel>
                      <Controller
                        name="property_ids"
                        control={control}
                        render={(field) => (
                          <Select
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            multiple
                            value={selectedProperties}
                            onChange={(e) => {
                              setSelectedProperties(typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value);
                              setValue("property_ids", e.target.value);
                            }}
                            input={<OutlinedInput id="select-multiple-chip" label="Property*" />}
                            renderValue={(selected) => {
                              return (<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                {propertyList.map((value) => {
                                  return selected?.indexOf(value?.id) > -1 ? (<Chip key={value?.id} label={value?.name} />) : null;
                                })}
                              </Box>);
                            }}
                            MenuProps={MenuProps}
                          >
                            {propertyList.map((item) => (<MenuItem key={item?.id} value={item?.id}>
                              <Checkbox checked={selectedProperties.indexOf(item.id) > -1} />
                              <ListItemText primary={item.name} />
                            </MenuItem>))}
                          </Select>)}
                      />
                    </FormControl>
                    {errors.property_ids && (<p className={`${styles.ErrorM}`}>{errors.property_ids.message}</p>)}
                  </div>
                </div>
                <div className={`${styles.AddDocTitleSec}`}>
                  <div className={`${styles.FormGroupAddLease} FormGroup`}>
                    <Controller
                      name={`title`}
                      control={control}
                      render={(field) => (<TextField {...field} id="outlined-basic" label="Community Board Title*" variant="outlined" />)}
                    />
                    {errors.title && (<p className={`${styles.ErrorM}`}>{errors?.title?.message}</p>)}
                  </div>
                </div>
                <div className={`${styles.AddDocTitleSec}`}>
                  <div className={`${styles.FormGroupAddLease} FormGroup`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name="start_date"
                        control={control}
                        render={(field) => (<DatePicker
                          {...field}
                          label="Start Date*"
                          renderInput={(params) => <TextField {...params} />}
                        />)}
                      />
                    </LocalizationProvider>
                    {errors.start_date && (<p className={`${styles.ErrorM}`}>
                      {errors.start_date.message}
                    </p>)}
                  </div>
                </div>
                <div className={`${styles.AddDocTitleSec}`}>
                  <div className={`${styles.FormGroupAddLease} FormGroup`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name="end_date"
                        control={control}
                        render={(field) => (<DatePicker
                          {...field}
                          label="End Date*"
                          renderInput={(params) => <TextField {...params} />}
                        />)}
                      />
                    </LocalizationProvider>
                    {errors.end_date && (<p className={`${styles.ErrorM}`}>
                      {errors.end_date.message}
                    </p>)}
                  </div>
                </div>
                <div className={`${styles.ButtonAction}`}>
                  <Link to={`/communication/community-boards`} className={`${styles.CancelPopupBU}`}>Cancel</Link>
                  <Button className={`${styles.SubmitPopupBU}`} type="submit">{isPublished ? "Publish" : "Save Draft"}</Button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

  </>);
};

export default AddArticle;